const Home = () => {
    return <div>
        <b>This is Home component</b>
    </div>
}

export default Home